import { ReleaseNotes } from '../components';
import { changelogReleases } from '../data';

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * Renders a complete changelog page with all production releases.
 */
const Changelog = () => (
  <div className="h-full w-full overflow-y-auto p-6">
    <div className="mx-auto flex max-w-7xl flex-col gap-10">
      <header>
        <h1 className="font-bold text-3xl">Release notes</h1>
        <p className="mt-2 text-muted-foreground">
          Production UI changes recovered from the deployed artifact history.
        </p>
      </header>

      {changelogReleases.length > 0 ? (
        changelogReleases.map((release) => <ReleaseNotes key={release.version} release={release} layout="accordion" />)
      ) : (
        <p role="status">No release notes are available.</p>
      )}
    </div>
  </div>
);

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { Changelog };
